<template>
  <div>
    <div class="tabbar">
      <van-tabbar v-model="active" :active-color="variables.theme" :fixed="false" route>
        <van-tabbar-item :to="{name: 'Home'}" icon="wap-home">首页</van-tabbar-item>
        <van-tabbar-item :to="{name: 'Cart'}" icon="shopping-cart" :badge="totalCartNum">购物车</van-tabbar-item>
        <van-tabbar-item :to="{name: 'User'}" icon="manager">我的</van-tabbar-item>
      </van-tabbar>
    </div>
    <div class="tabbar--placeholder" style="width:100%;height:50px" />
  </div>
</template>

<script>
import variables from '@/styles/variables.scss'
import { getCartGoodsCount } from '@/api/cart'

export default {
  data() {
    return {
      active: 0,
      count: 0
    }
  },
  computed: {
    variables() {
      return variables
    },
    totalCartNum() {
      if (this.count === 0) {
        return ''
      } else {
        return this.count <= 99 ? this.count : 99
      }
    }
  },
  mounted() {
    this.getCartGoodsCount()
  },
  methods: {
    getCartGoodsCount() {
      getCartGoodsCount().then(res => {
        const { data } = res
        this.count = data
      }).catch(e => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.tabbar {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 999;

  ::v-deep .van-tabbar {
    background-color: #A33030 !important;
    border-top: none;
  }

  ::v-deep .van-tabbar-item {
    color: rgba(255, 255, 255, 0.7) !important;
    background-color: transparent !important;

    &.van-tabbar-item--active {
      color: #fff !important;
      background-color: transparent !important;
    }

    .van-icon {
      color: rgba(255, 255, 255, 0.7) !important;
    }

    &.van-tabbar-item--active .van-icon {
      color: #fff !important;
    }
  }

  ::v-deep .van-tabbar-item__icon {
    background-color: transparent !important;
  }
}

</style>
